(function () {
  'use strict';

  var config = window.vpBulkDiscountsLocalization;
  if (!config || !config.labels || !config.groupTitles) return;

  var wrapperSelector = '.quantity-breaks-now-wrapper';
  var groupSelector = '.quantity-breaks-now-discount-tiers[id^="discount-group-"]';
  var scheduled = false;
  var timers = [];

  function getGroupId(group) {
    return group.id.replace('discount-group-', '');
  }

  function isMappedGroup(groupId) {
    return Object.prototype.hasOwnProperty.call(config.groupTitles, groupId);
  }

  function setText(element, value) {
    if (element && element.textContent !== value) {
      element.textContent = value;
    }
  }

  function isZeroCurrency(value) {
    var digits = String(value || '').replace(/\D/g, '');
    return digits !== '' && /^0+$/.test(digits);
  }

  function updateInvalidPrice(group, isMapped) {
    var table = group.querySelector('.quantity-breaks-now-discount-table');
    if (!table || !isMapped || config.locale === 'he') return;

    var rows = table.querySelectorAll('tbody tr');
    for (var index = 0; index < rows.length; index += 1) {
      var cell = rows[index].children[2];
      if (!cell) continue;

      if (isZeroCurrency(cell.textContent)) {
        cell.classList.add('vp-bulk-discounts-invalid-price');
        cell.setAttribute('aria-hidden', 'true');
      } else {
        cell.classList.remove('vp-bulk-discounts-invalid-price');
        cell.removeAttribute('aria-hidden');
      }
    }
  }

  function localizeGroup(group) {
    var groupId = getGroupId(group);
    var isMapped = isMappedGroup(groupId);
    var title = group.querySelector('.quantity-breaks-now-discount-title');
    var table = group.querySelector('.quantity-breaks-now-discount-table');
    var headers;

    if (config.locale !== 'he') {
      setText(title, isMapped ? config.groupTitles[groupId] : config.labels.genericTitle);
    }

    if (table && config.locale !== 'he') {
      headers = table.querySelectorAll('th');
      if (headers.length === 3) {
        setText(headers[0], config.labels.minimumQuantity);
        setText(headers[1], config.labels.discountPerUnit);
        setText(headers[2], config.labels.discountedPrice);
      }
    }

    updateInvalidPrice(group, isMapped);
  }

  function applyLocalization() {
    var wrappers = document.querySelectorAll(wrapperSelector);
    for (var wrapperIndex = 0; wrapperIndex < wrappers.length; wrapperIndex += 1) {
      var wrapper = wrappers[wrapperIndex];
      wrapper.setAttribute('data-vp-bulk-discounts-localized', 'true');
      wrapper.setAttribute('data-vp-bulk-discounts-direction', config.direction);

      var groups = wrapper.querySelectorAll(groupSelector);
      for (var groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
        localizeGroup(groups[groupIndex]);
      }
    }
  }

  function scheduleLocalization() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      applyLocalization();
    }, 50);
  }

  function scheduleVariantRefreshes() {
    while (timers.length) {
      window.clearTimeout(timers.pop());
    }

    [0, 250, 1000, 3000, 7000, 12000].forEach(function (delay) {
      timers.push(window.setTimeout(applyLocalization, delay));
    });
  }

  function start() {
    var scope = document.querySelector('#ProductSection-product-template') || document.querySelector('.product-template__container') || document.querySelector('main');
    if (!scope) return;

    applyLocalization();
    scheduleVariantRefreshes();

    new MutationObserver(scheduleLocalization).observe(scope, { childList: true, subtree: true });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('select[name="id"], input[name="id"], select[name="id[]"]')) {
        scheduleVariantRefreshes();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
